// Liste des pays (FR) avec code ISO pour drapeaux et nationalités
export const COUNTRIES = [
  { code: 'FR', name: 'France', nationality: 'Française' },
  { code: 'BE', name: 'Belgique', nationality: 'Belge' },
  { code: 'CH', name: 'Suisse', nationality: 'Suisse' },
  { code: 'LU', name: 'Luxembourg', nationality: 'Luxembourgeoise' },
  { code: 'MC', name: 'Monaco', nationality: 'Monégasque' },
  { code: 'CA', name: 'Canada', nationality: 'Canadienne' },
  { code: 'DE', name: 'Allemagne', nationality: 'Allemande' },
  { code: 'IT', name: 'Italie', nationality: 'Italienne' },
  { code: 'ES', name: 'Espagne', nationality: 'Espagnole' },
  { code: 'PT', name: 'Portugal', nationality: 'Portugaise' },
  { code: 'NL', name: 'Pays-Bas', nationality: 'Néerlandaise' },
  { code: 'GB', name: 'Royaume-Uni', nationality: 'Britannique' },
  { code: 'IE', name: 'Irlande', nationality: 'Irlandaise' },
  { code: 'US', name: 'États-Unis', nationality: 'Américaine' },
  { code: 'AT', name: 'Autriche', nationality: 'Autrichienne' },
  { code: 'DK', name: 'Danemark', nationality: 'Danoise' },
  { code: 'FI', name: 'Finlande', nationality: 'Finlandaise' },
  { code: 'GR', name: 'Grèce', nationality: 'Grecque' },
  { code: 'IS', name: 'Islande', nationality: 'Islandaise' },
  { code: 'NO', name: 'Norvège', nationality: 'Norvégienne' },
  { code: 'PL', name: 'Pologne', nationality: 'Polonaise' },
  { code: 'CZ', name: 'République tchèque', nationality: 'Tchèque' },
  { code: 'RO', name: 'Roumanie', nationality: 'Roumaine' },
  { code: 'SE', name: 'Suède', nationality: 'Suédoise' },
  { code: 'HU', name: 'Hongrie', nationality: 'Hongroise' },
  { code: 'BG', name: 'Bulgarie', nationality: 'Bulgare' },
  { code: 'HR', name: 'Croatie', nationality: 'Croate' },
  { code: 'EE', name: 'Estonie', nationality: 'Estonienne' },
  { code: 'LV', name: 'Lettonie', nationality: 'Lettonne' },
  { code: 'LT', name: 'Lituanie', nationality: 'Lituanienne' },
  { code: 'SK', name: 'Slovaquie', nationality: 'Slovaque' },
  { code: 'SI', name: 'Slovénie', nationality: 'Slovène' },
  { code: 'MT', name: 'Malte', nationality: 'Maltaise' },
  { code: 'CY', name: 'Chypre', nationality: 'Chypriote' },
  { code: 'TR', name: 'Turquie', nationality: 'Turque' },
  { code: 'MA', name: 'Maroc', nationality: 'Marocaine' },
  { code: 'DZ', name: 'Algérie', nationality: 'Algérienne' },
  { code: 'TN', name: 'Tunisie', nationality: 'Tunisienne' },
  { code: 'EG', name: 'Égypte', nationality: 'Égyptienne' },
  { code: 'SN', name: 'Sénégal', nationality: 'Sénégalaise' },
  { code: 'CI', name: 'Côte d’Ivoire', nationality: 'Ivoirienne' },
  { code: 'CM', name: 'Cameroun', nationality: 'Camerounaise' },
  { code: 'CG', name: 'Congo', nationality: 'Congolaise' },
  { code: 'CD', name: 'République démocratique du Congo', nationality: 'Congolaise (RDC)' },
  { code: 'GA', name: 'Gabon', nationality: 'Gabonaise' },
  { code: 'BJ', name: 'Bénin', nationality: 'Béninoise' },
  { code: 'BF', name: 'Burkina Faso', nationality: 'Burkinabè' },
  { code: 'ML', name: 'Mali', nationality: 'Malienne' },
  { code: 'NE', name: 'Niger', nationality: 'Nigérienne' },
  { code: 'TG', name: 'Togo', nationality: 'Togolaise' },
  { code: 'MG', name: 'Madagascar', nationality: 'Malgache' },
  { code: 'MU', name: 'Maurice', nationality: 'Mauricienne' },
  { code: 'RE', name: 'La Réunion', nationality: 'Réunionnaise' },
  { code: 'GF', name: 'Guyane française', nationality: 'Guyanaise' },
  { code: 'MQ', name: 'Martinique', nationality: 'Martiniquaise' },
  { code: 'GP', name: 'Guadeloupe', nationality: 'Guadeloupéenne' },
  { code: 'PF', name: 'Polynésie française', nationality: 'Polynésienne' },
  { code: 'NC', name: 'Nouvelle-Calédonie', nationality: 'Calédonienne' },
  { code: 'YT', name: 'Mayotte', nationality: 'Mahoraise' },
  { code: 'BR', name: 'Brésil', nationality: 'Brésilienne' },
  { code: 'AR', name: 'Argentine', nationality: 'Argentine' },
  { code: 'MX', name: 'Mexique', nationality: 'Mexicaine' },
  { code: 'CL', name: 'Chili', nationality: 'Chilienne' },
  { code: 'CO', name: 'Colombie', nationality: 'Colombienne' },
  { code: 'PE', name: 'Pérou', nationality: 'Péruvienne' },
  { code: 'VE', name: 'Venezuela', nationality: 'Vénézuélienne' },
  { code: 'JP', name: 'Japon', nationality: 'Japonaise' },
  { code: 'CN', name: 'Chine', nationality: 'Chinoise' },
  { code: 'KR', name: 'Corée du Sud', nationality: 'Coréenne' },
  { code: 'IN', name: 'Inde', nationality: 'Indienne' },
  { code: 'TH', name: 'Thaïlande', nationality: 'Thaïlandaise' },
  { code: 'VN', name: 'Vietnam', nationality: 'Vietnamienne' },
  { code: 'PH', name: 'Philippines', nationality: 'Philippine' },
  { code: 'ID', name: 'Indonésie', nationality: 'Indonésienne' },
  { code: 'AU', name: 'Australie', nationality: 'Australienne' },
  { code: 'NZ', name: 'Nouvelle-Zélande', nationality: 'Néo-zélandaise' },
  { code: 'AE', name: 'Émirats arabes unis', nationality: 'Émirienne' },
  { code: 'SA', name: 'Arabie saoudite', nationality: 'Saoudienne' },
  { code: 'QA', name: 'Qatar', nationality: 'Qatarie' },
  { code: 'IL', name: 'Israël', nationality: 'Israélienne' },
  { code: 'LB', name: 'Liban', nationality: 'Libanaise' },
  { code: 'JO', name: 'Jordanie', nationality: 'Jordanienne' },
  { code: 'ZA', name: 'Afrique du Sud', nationality: 'Sud-africaine' },
  { code: 'NG', name: 'Nigeria', nationality: 'Nigériane' },
  { code: 'KE', name: 'Kenya', nationality: 'Kényane' },
  { code: 'ET', name: 'Éthiopie', nationality: 'Éthiopienne' },
];

// Convert ISO code to flag emoji (regional indicator)
export function flagEmoji(code) {
  if (!code || code.length !== 2) return '🌐';
  const A = 0x1F1E6;
  return String.fromCodePoint(...code.toUpperCase().split('').map((c) => A + c.charCodeAt(0) - 65));
}
